import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { Customer } from '../../models/customer.model';
import { Role } from '../../models/role.model';
import { UserEdit } from '../../models/user-edit.model';
import { User } from '../../models/user.model';
import { AccountService } from '../../services/account.service';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { fadeInOut } from '../../services/animations';
import { Utilities } from '../../services/utilities';

var _ = require('lodash');

@Component({
    selector: 'register',
    template: require('./register.component.html'),
    styles: [require('./register.component.css')],
    animations: [fadeInOut]
})
export class RegisterComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];

    user: User = new User;
    userEdit: UserEdit = new UserEdit;
    gdprCBChecked: boolean = false;
    isProcessing: boolean = false;

    loading: boolean = false;
    allRoles: Role[] = [];
    rrole: Role[] = [];
    isMailSent: boolean = false;
    selectedData: any;
    applicationTrialDays: number;
    ddRegisterTypes: Array<{ label: string, value: string }> = new Array();

    constructor(private userService: AccountService, private router: Router, private activatedRoute: ActivatedRoute, private alertService: AlertService, private ngxLogger: NGXLogger) {
    }

    ngOnInit() {
        this.ddRegisterTypes = [
            { label: 'Bedrijf', value: 'B' },
            { label: 'Particulier', value: 'P' }
        ];

        const paramSubscriber = this.activatedRoute.params.subscribe(params => {
            this.userEdit.Customer = new Customer();
            this.userEdit.Customer.CustomerRegistrationType = 'B';
            this.userEdit.IsEnabled = false;
        });
        this.subscribers.push(paramSubscriber);
        this.getRoles();
        const getTempApplicationTrialDaysSub = this.userService.getTempApplicationTrialDays().subscribe(res => {
            this.applicationTrialDays = +res;
        });
        this.subscribers.push(getTempApplicationTrialDaysSub);
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    getRoles() {
        const rolesSubscriber = this.userService.getRoles().subscribe(response => {
            this.allRoles = response;
            this.rrole = this.allRoles;
            this.userEdit.RoleId = this.rrole[0].Name;
        });
        this.subscribers.push(rolesSubscriber);
    }

    createUpdate(form: NgForm) {
        if (this.gdprCBChecked) {
            this.userEdit.UserName = this.userEdit.Email;
            this.userEdit.Email = this.userEdit.Customer.Email;

            if (form.valid) {
                if (this.userEdit.Customer.CustomerRegistrationType === 'P') {
                    this.userEdit.Customer.Company = null;
                    this.userEdit.Customer.BTW = null;
                }
                this.isProcessing = true;
                const newPublicSubscriber = this.userService.newPublicUser(this.userEdit).subscribe(user => {
                    this.isMailSent = true;
                    this.isProcessing = false;
                }, error => {
                    this.isProcessing = false;
                    const errorMessage = Utilities.findHttpResponseMessage("error_description", error);
                    if (errorMessage == 'Email Exists') {
                        this.alertService.showMessage(this.userEdit.Email, 'bestaat al!', MessageSeverity.error);
                    } else if (errorMessage == 'BTW Exists') {
                        this.alertService.showMessage(this.userEdit.Customer.BTW, 'bestaat al!', MessageSeverity.error);
                    } else {
                        this.alertService.showStickyMessage('Fout', 'Er is iets fout gegaan', MessageSeverity.error);
                    }
                });
                this.subscribers.push(newPublicSubscriber);
            }
        }
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/register/register.component.ts